import { defineStore } from 'pinia'

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    visible: false,
    text: '',
    timeout: 5000,
    color: 'success',
    multiline: false
  }),
  actions: {
    showSnackbar({ text, color = 'success', multiline, timeout = 5000 }) {
      this.text = text
      this.color = color
      this.multiline = multiline ?? text.length > 50
      this.timeout = timeout
      this.visible = true
    }
  }
})
